import React, { useState, useEffect } from "react";
import AdminDashboardLayout from "../../../layout/AdminDashboardLayout";
import { StyledContainer } from "../../../globalStyle/GlobalStyle";
import { ParametersWrapper } from "../Parameters.styled";
import { FormContainer, StyledForm } from "../../../components/Form/FormComponents.styled";
import { InputField } from "../../../components/Form/FormComponents";
import { Backdrop, Button, CircularProgress } from "@mui/material";
import { BiArrowBack } from "react-icons/bi";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { setVariables } from "../ParameterSlice";
import { updateVariables } from "../utils";

const InputVariables = () => {
	const dispatch = useDispatch();
	const variablesOptions = useSelector((state) => state.parameters.variables);
	const [formDataPeriod, setFormDataPeriod] = useState([]);
	const [formDataTerms, setFormDataTerms] = useState([]);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		configFormData(variablesOptions);
	}, []);

	const configFormData = (variablesOptions) => {
		console.log(variablesOptions);
		const inputValuesPeriod = variablesOptions?.period.map((item, index) => {
			return { name: "period" + index, value: item };
		});
		const inputValuesTerms = variablesOptions?.terms.map((item, index) => {
			return { name: "term" + index, value: item };
		});
		setFormDataPeriod([...inputValuesPeriod, { name: "period" + inputValuesPeriod.length, value: "" }]);
		setFormDataTerms([...inputValuesTerms, { name: "term" + inputValuesTerms.length, value: "" }]);
	};

	const handleInputChangeP = (e) => {
		const { name, value } = e.target;
		setFormDataPeriod((prevState) => {
			return prevState.map((item) => {
				if (item.name === name) return { ...item, value };
				return item;
			});
		});
	};

	const handleInputChangeT = (e) => {
		const { name, value } = e.target;
		setFormDataTerms((prevState) => {
			return prevState.map((item) => {
				if (item.name === name) return { ...item, value };
				return item;
			});
		});
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		setLoading(true);
		let period = formDataPeriod.filter((item) => item.value !== "").map((item) => item.value);
		let terms = formDataTerms.filter((item) => item.value !== "").map((item) => item.value);
		console.log(period, terms);

		let data = updateVariables({ period, terms });
		data.then((res) => {
			if (res && !res.error) {
				dispatch(setVariables({ period, terms }));
				configFormData({ period, terms });
				setLoading(false);
				toast.success("Input variables updated successfully!");
			} else {
				setLoading(false);
				toast.error("Error updating input variables!");
			}
		});
	};

	return (
		<AdminDashboardLayout>
			<StyledContainer>
				<ParametersWrapper>
					<Link
						to='/parameters'
						style={{ color: "#408D94", width: "fit-content", marginBottom: "2.25rem" }}
						className='flex gap-2 border '>
						<BiArrowBack size={24} />
						<p>Go back</p>
					</Link>

					<FormContainer>
						<StyledForm onSubmit={handleSubmit}>
							<div className='parametersList w-full'>
								<div className='grid grid-cols-2 gap-8'>
									<div className='heading mb-0'>Period</div>
									<div className='heading mb-0'>Terms</div>
								</div>

								<div className='grid grid-cols-2 gap-8'>
									<div className='listItem' style={{ alignContent: "start" }}>
										{formDataPeriod?.map((item, index) => (
											<div key={index} className='form-group'>
												<InputField
													name={item.name}
													handleChange={(e) => handleInputChangeP(e)}
													isEditable={true}
													placeholder='Enter variable'
													value={item.value}
												/>
											</div>
										))}
									</div>

									<div className='listItem' style={{ alignContent: "start" }}>
										{formDataTerms?.map((item, index) => (
											<div key={index} className='form-group'>
												<InputField
													name={item.name}
													handleChange={(e) => handleInputChangeT(e)}
													isEditable={true}
													placeholder='Enter variable'
													value={item.value}
												/>
											</div>
										))}
									</div>
								</div>

								<div className='actions flex mt-5' style={{}}>
									<Button variant='contained' type='submit'>
										Save
									</Button>
								</div>
							</div>
						</StyledForm>
					</FormContainer>
				</ParametersWrapper>
			</StyledContainer>

			{loading && (
				<Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
					<CircularProgress color='inherit' />
				</Backdrop>
			)}
		</AdminDashboardLayout>
	);
};

export default InputVariables;
